export const BATCHES_LIST = 'BATCHES_LIST'
export const ORGANISSED_BATCHES_LIST = 'ORGANISSED_BATCHES_LIST'
export const UNORGANISSED_BATCHES_LIST = 'UNORGANISSED_BATCHES_LIST'
export const BATCH_LOADER = 'BATCH_LOADER'
export const BATCH_DIRECTORY = 'BATCH_DIRECTORY'
export const BATCH_DETAIL = 'BATCH_DETAIL'
